var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    width: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.3 12.2c1.1-.9 1.7-2.3 1.7-3.7 0-2.8-2.2-5-5-5s-5 2.2-5 5c0 1.4.6 2.8 1.7 3.7-2.8 1.3-4.7 4.2-4.7 7.3 0 .6.4 1 1 1s1-.4 1-1c0-3.3 2.7-6 6-6s6 2.7 6 6c0 .6.4 1 1 1s1-.4 1-1c0-3.1-1.8-6-4.7-7.3zm-3.3-.7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm9.8.3c1.8-2.1 1.6-5.2-.4-7.1-.9-.8-2.1-1.3-3.3-1.3-.6 0-1 .4-1 1s.4 1 1 1c1.7 0 3 1.3 3 3 0 1.1-.6 2.1-1.5 2.6-.3.2-.5.5-.5.8s.2.7.5.9l.4.3.1.1c2.5 1.2 4 3.7 4 6.4 0 .6.4 1 1 1s1-.4 1-1c-.1-3.1-1.7-6-4.3-7.7z",
    fill: "#4ba7fd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/userGroup.772ab5a8dd61c352378d0dfb9502a44f.svg";
export { ForwardRef as ReactComponent };